import "./index.scss"
import "./static/hero-bg.jpg"
import "./static/hero-bg.webp"
import "./static/icon-search.svg"

require.context("./static", true, /\.svg|jpg|webp$/)
